"use strict";
exports.__esModule = true;
exports.DOMUtils = void 0;
var DOMUtils = /** @class */ (function () {
    function DOMUtils() {
    }
    DOMUtils.selectOne = function (selector) {
        return document.querySelector(selector);
    };
    DOMUtils.val = function (selector, value) {
        var el = this.selectOne(selector);
        if (!el)
            return undefined;
        if (typeof value === "string") {
            var oldValue = el.value;
            el.value = value;
            return oldValue;
        }
        else {
            return el.value;
        }
    };
    return DOMUtils;
}());
exports.DOMUtils = DOMUtils;
//# sourceMappingURL=DOMUtils.js.map